import {token} from "@atlaskit/tokens";
import {AnankeSelect} from "@vesta/ananke/components/anankeSelect";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {CustomerProfileNotesLifecycleOption} from "~/components/entityProfile/customerProfileDataSource/types";

export function ProfileCustomerNotesLifecycleSelect({
    options,
    value,
    onChange,
    isDisabled = false,
}: {
    options: Array<CustomerProfileNotesLifecycleOption>;
    value: Uuid | null;
    onChange: (next: Uuid) => void;
    isDisabled?: boolean;
}) {
    const selectOptions = options.map((option) => ({
        value: option.id,
        label: option.label,
    }));
    const selectedOption = selectOptions.find((option) => option.value === value) ?? null;

    return (
        <div className="grid w-full min-w-0 gap-ds-space-050">
            <label
                className="font-ds-font-weight-medium text-[0.875rem] leading-ds-space-250"
                style={{color: token("color.text.subtle"), fontFamily: "Inter"}}
            >
                Lifecycle
                <span style={{color: token("color.text.danger")}} aria-hidden={true}>
                    {" "}
                    *
                </span>
            </label>
            <AnankeSelect
                isDisabled={isDisabled === true || options.length === 0}
                placeholder="Select lifecycle"
                menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                menuPosition="fixed"
                maxMenuHeight={280}
                styles={{
                    menuPortal: (base: Record<string, unknown>) => ({...base, zIndex: 9999}),
                }}
                value={selectedOption}
                onChange={(newValue: {value: Uuid; label: string} | null) => {
                    if (newValue === null) {
                        return;
                    }
                    onChange(newValue.value);
                }}
                options={selectOptions}
            />
        </div>
    );
}
